import React from 'react'
import { Tab } from 'evergreen-ui'
import { Link as RouterLink } from 'react-router'
import { functionsPath } from 'lib/path-helpers/functions'
import { sourcesCatalogPath } from 'lib/path-helpers/sources'
import { destinationsCatalogPath } from 'lib/path-helpers/destinations'
import useRouter from 'hooks/use-router'
import NavigationBar from 'containers/Functions/components/NavigationBar'

const CatalogNavigationBar: React.FC = () => {
  const router = useRouter()
  const { workspaceSlug } = router.params

  return (
    <NavigationBar>
      <Tab is={RouterLink} to={sourcesCatalogPath({ workspaceSlug })} marginLeft={0}>
        Sources
      </Tab>
      <Tab is={RouterLink} to={destinationsCatalogPath({ workspaceSlug })}>
        Destinations
      </Tab>
      <Tab is={RouterLink} to={destinationsCatalogPath({ workspaceSlug, query: { category: 'Warehouses' } })}>
        Warehouses
      </Tab>
      <Tab is={RouterLink} to={functionsPath({ workspaceSlug })} isSelected>
        Functions
      </Tab>
    </NavigationBar>
  )
}

export default CatalogNavigationBar
